<div
  class="card-wrapper"
  [class.card-wrapper--no-padding]="noPadding"
  [class.card-wrapper--overflow_hidden]="overflow"
  [class]="innerClass ? innerClass : ''"
>
  <div class="card-wrapper__content" [class]="innerClass ? innerClass + '-content' : ''">
    <ng-content></ng-content>
  </div>
</div>
